import { ComponentProps, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface ProductImageProps {
  fallbackProps?: {
    className?: string;
    showMessage?: boolean;
  };
  imageProps?: ComponentProps<'img'>;
}

export function ProductImage({ fallbackProps, imageProps }: ProductImageProps) {
  const [error, setError] = useState(false);

  const { t } = useTranslation('translation', {
    keyPrefix: 'components.ProductImageFallback',
  });

  return (
    <>
      {!error && <img {...imageProps} onError={() => setError(true)} />}

      {error && (
        <div
          className={cn(
            'flex h-full w-full flex-col items-center justify-center bg-gray-100 p-4 text-gray-500',
            fallbackProps?.className,
          )}
        >
          <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-lg bg-gray-200">
            <svg
              className="h-8 w-8 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>

          {fallbackProps?.showMessage && (
            <span className="text-sm font-medium">{t('message')}</span>
          )}
        </div>
      )}
    </>
  );
}
